import { Component } from '../component/component';

export class DownloadItem extends Component {

	constructor(item) {
		super();
		this.item = item;
		this.node = this.getNode();
	}

	getTemplate() {
		const template = /* html */`<li>
			<a target="_blank" rel="nofollow noopener noreferrer" href="${this.item.fileUrl}" title="${this.item.fileName}">${this.item.fileType}</a>
		</li>`;
		return template;
	}

}
